package com.tedd.db

import kotlin.Long
import kotlin.String

public data class SelectToUpload(
  public val id: String,
  public val owner_kind: String,
  public val owner_id: String,
  public val file_name: String,
  public val mime_type: String,
  public val size_bytes: Long,
  public val storage_key: String?,
  public val sha256: String?,
  public val width: Long?,
  public val height: Long?,
  public val status: String,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long,
)
